import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";

const getDefaultState = () => {
  return {
    dailyminMaxInfo: {
      ogvtn: {
        simpleBtnArr: [
          { view: "max", amt: "0" },
          { view: "+500,000K", amt: "500000000" },
          { view: "+100,000K", amt: "100000000" },
        ],
      },
      ogcbd: {
        simpleBtnArr: [
          { view: "max", amt: "0" },
          { view: "+100,000", amt: "100000" },
          { view: "+50,000", amt: "50000" },
        ],
      },
    },
    casPerminMaxInfo: {
      ogvtn: {
        simpleBtnArr: [
          { view: "max", amt: "0" },
          { view: "+100,000K", amt: "100000000" },
          { view: "+50,000K", amt: "50000000" },
          { view: "+10,000K", amt: "10000000" },
        ],
      },
      ogcbd: {
        simpleBtnArr: [
          { view: "max", amt: "0" },
          { view: "+5,000", amt: "5000" },
          { view: "+1,000", amt: "1000" },
        ],
      },
    },
    /**
     * 이체한도 & 입력방법 설정
     */
    trsaccClam: {
      in: {
        dailyTrsaccClam: "", // 일일이체한도
        casPerTrsaccClam: "", // 건별이체한도금액
        certnDmndCd: "1", // 인증요청코드(1:자동, 2:수동)
      },
      out: {
        success: {
          trsaccClamResult: "",
        },
        fail: {},
      },
    },
    /**
     * 은행기본이체한도조회
     */
    RBF0402N40: {
      in: {},
      out: {
        success: {
          ppsnCoprDstcd: "", // 개인법인구분코드
          cncycd: "", // 통화코드
          dailyTrsaccClam: 0, // 일일이체한도금액
          casPerTrsaccClam: 0, // 건별이체한도금액
        },
        fail: {},
      },
    },
    /**
     * mOTP init
     */
    initMotp: {
      in: {},
      out: {
        success: {
          mOtpId: "", // mOTP iD
          systemId: "", // mOTP systemId
          wwwBnkgLginID: "",
          otpStusDstcd: "",
          issuncYMS: "",
          SmphMchtlUniqNo: "",
          lastCertnSucssYMS: "",
          totalCertnErrNotms: "",
          certnErrNotms: "",
          outItem: {
            ppsnCoprDstcd: "", // 개인법인구분코드
            cncycd: "", // 통화코드
            dailyTrsaccClam: 0, // 일일이체한도금액
            casPerTrsaccClam: 0, // 건별이체한도금액
          },
        },
        fail: {},
      },
    },
    SSInfogetMotp: {
      in: {},
      out: [
        // {
        // 	strUserId: "G21000009100000"
        // , secret: "dfefewfsdfadsafasdfasdfsdf...."
        // }
      ],
    },
    MotpisIssuncYn: "",
  };
};

const certnStupModfiMotp = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getTrsaccClam: state => {
      return state.trsaccClam;
    },
    getRBF0402N40: state => {
      return state.RBF0402N40;
    },
    getSSInfogetMotp: state => {
      return state.SSInfogetMotp;
    },
    getMotpisIssuncYn: state => {
      return state.MotpisIssuncYn;
    },
    getInitMotp: state => {
      return state.initMotp;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut001: function(state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },
    mut006: function(state, payload) {
      this._vm.$set(state.trsaccClam.in, payload.key, " ");
      payload.value = this._vm.$removeComma(String(payload.value));
      payload.value = Number(payload.value);
      if (payload.key === "dailyTrsaccClam") {
        if (Number(payload.value) > Number(state.RBF0402N40.out.success.dailyTrsaccClam)) {
          payload.value = state.RBF0402N40.out.success.dailyTrsaccClam;
        }
      }
      if (payload.key === "casPerTrsaccClam") {
        if (Number(payload.value) > Number(state.RBF0402N40.out.success.casPerTrsaccClam)) {
          payload.value = state.RBF0402N40.out.success.casPerTrsaccClam;
        }
      }
      this._vm.$set(state.trsaccClam.in, payload.key, payload.value);
    },
    mut012: function(state, payload) {
      this._vm.$set(state.RBF0402N40.out.success, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * mOTP 인증설정 init
     */
    act001: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/certnStupModfi/initMotp",
          this.state.auth.certnStupModfiMotp.initMotp.in,
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.initMotp.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.initMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },

    /**
     * 이체한도 가져오기
     */
    act012: function(context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/certnStupModfi/initTrsaccClam",
          this.state.auth.certnStupModfiMotp.initMotp.in,
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.initMotp.out.success, "systemId", response.systemId);
            this._vm.$set(this.state.auth.certnStupModfiMotp.initMotp.out.success, "mOtpId", response.mOtpId);
            // 은행이체한도set
            for (const k in response.outItem) {
              context.commit("mut012", { key: k, value: response.outItem[k] });
            }

            context.state.dailyminMaxInfo[this.state.siteCode].simpleBtnArr.forEach(e => {
              if (e.view === "max") {
                e.amt = response.outItem.dailyTrsaccClam;
              }
            });

            context.state.casPerminMaxInfo[this.state.siteCode].simpleBtnArr.forEach(e => {
              if (e.view === "max") {
                e.amt = response.outItem.casPerTrsaccClam;
              }
            });

            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.createMotp.initMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 이체한도 & 입력방법 설정
     */
    act008: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/certnStupModfi/trsaccClam",
          this.state.auth.certnStupModfiMotp.trsaccClam.in,
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.trsaccClam.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.trsaccClam.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    act009: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/certnStupModfi/trsaccClam_1",
          this.state.auth.certnStupModfiMotp.trsaccClam.in,
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.trsaccClam.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.certnStupModfiMotp.trsaccClam.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },

    /**
     * 기기정보 후 처리
     */
    act014: function() {
      // console.log("certnStupModfiMotp smphMchtlUniqNo---------->" + this.state.native.smphMchtlUniqNo);
      // console.log("certnStupModfiMotp mOtpId---------->" + this.state.auth.certnStupModfiMotp.initMotp.out.success.mOtpId);
      // console.log("certnStupModfiMotp strUserId------>", this.state.auth.certnStupModfiMotp.SSInfogetMotp.out);
      // console.log("certnStupModfiMotp otpStusDstcd------>", this.state.auth.certnStupModfiMotp.initMotp.out.success.otpStusDstcd);
      // console.log("certnStupModfiMotp systemId------>", this.state.auth.certnStupModfiMotp.initMotp.out.success.systemId);
      // console.log("certnStupModfiMotp SmphMchtlUniqNo------>", this.state.auth.certnStupModfiMotp.initMotp.out.success.SmphMchtlUniqNo);

      // 현재 폰에 정상인 mOTP가 있는 경우.
      if (
        this.state.auth.certnStupModfiMotp.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.certnStupModfiMotp.initMotp.out.success.mOtpId;
        }).length > 0 &&
        (this.state.auth.certnStupModfiMotp.initMotp.out.success.otpStusDstcd === "030" ||
          this.state.auth.certnStupModfiMotp.initMotp.out.success.otpStusDstcd === "140" ||
          this.state.auth.certnStupModfiMotp.initMotp.out.success.otpStusDstcd === "150") &&
        this.state.auth.certnStupModfiMotp.initMotp.out.success.SmphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        this.state.auth.certnStupModfiMotp.MotpisIssuncYn = "Y";
        // console.log("인증설정변경 OK---->현재 폰에 정상인 mOTP가 있는 경우");
      } else {
        this.state.auth.certnStupModfiMotp.MotpisIssuncYn = "N";
        // console.log("인증설정변경  NO---->현재 폰에 비정상인 mOTP가 있는 경우");
        router.push({ name: "certnStupModfiMotpStep7" }); //motp발급정보없음
      }
    },
  },
};

export default certnStupModfiMotp;
